import React from "react";
import SocialLogin from "react-social-login";
import styles from "../styles";

const SocialFacebook = ({ children, onClick, triggerLogin }) => (
  <button
    type="button"
    style={styles.buttonFacebook}
    onClick={() => typeof onClick === 'function' ? onClick() : triggerLogin()}
  >
    {children}
  </button>
);

export default SocialLogin(SocialFacebook);
